// File: /opt/dev_environment/assets/workspace/app-init/src/components/Layout/Layout.js

import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { NAV_ITEMS } from '../../constants/leitner';
import NavIcon from '../NavIcon/NavIcon';
import UserMenu from '../UserMenu/UserMenu';
import './Layout.css';

function Layout({ children }) {
  const location = useLocation();

  return (
    <div className="layout">
      {/* Header */}
      <header className="layout__header">
        <h1 className="layout__header-title">
          <span className="layout__header-icon" role="img" aria-label="Karteikasten">
            🗃️
          </span>
          Vokabelkasten
        </h1>
        <div className="layout__header-actions">
          <UserMenu />
        </div>
      </header>

      {/* Main Content Area */}
      <main className="layout__main">
        {children}
      </main>

      {/* Bottom Navigation */}
      <nav className="layout__bottom-nav" aria-label="Hauptnavigation">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`layout__nav-item ${isActive ? 'layout__nav-item--active' : ''}`}
              aria-current={isActive ? 'page' : undefined}
            >
              <span className="layout__nav-icon">
                <NavIcon name={item.icon} />
              </span>
              <span className="layout__nav-label">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}

export default Layout;